var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-menu", class: "depth" + _vm.depth },
    [
      _c(
        "vue-client-only",
        [
          _c("mobile-menu-header", {
            attrs: { title: _vm.headerTitle, "show-back": _vm.depth > 1 },
            on: { back: _vm.back }
          })
        ],
        1
      ),
      _vm.depth === 1 ? _vm._t("prepend") : _vm._e(),
      _c(
        "div",
        { staticClass: "tree-menu-container" },
        _vm._l(_vm.items, function(group, i) {
          return _c(
            "ul",
            { key: i, class: { "root-categories": _vm.depth === 1 } },
            _vm._l(group, function(item) {
              return _c(
                "li",
                {
                  key: item.url,
                  class: {
                    active: !!item.url && item.url === _vm.activeItem.url
                  }
                },
                [
                  _c("a", {
                    staticClass: "link",
                    style: { color: item.color },
                    attrs: { href: item.url },
                    domProps: { textContent: _vm._s(item.name) },
                    on: {
                      click: function($event) {
                        return _vm.itemClick($event, item)
                      }
                    }
                  }),
                  item.items && item.items.length && _vm.depth < _vm.maxDepth
                    ? _c("tree-menu", {
                        attrs: {
                          items: item.items,
                          depth: _vm.depth + 1,
                          "max-depth": _vm.maxDepth,
                          path: _vm.path.concat([item.name])
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        }),
        0
      ),
      _vm.depth === 1 ? _vm._t("append") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }